import React from "react";
import {
  Box,
  TextField,
  Button,
  IconButton,
  InputAdornment
} from "@mui/material";
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel'
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined"; 
import { useAuth } from "../../components/auth/AuthProvider";

export default function ActReportsHeaderActions({ searchText, onSearchChange, onNewRequest, onOpenColumns, onOpenFilters, onHandleStatus}) {
  const { user, role } = useAuth();
  console.log("Role: ", role);

  const switchLabel = { inputProps: { 'aria-label': 'Hide Complete' } };

  const [checked, setChecked] = React.useState(true)

  const handleChange = (event) => {
    const newValue = event.target.checked;
    setChecked(newValue);
    if(onHandleStatus) {
        onHandleStatus(newValue);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        bgcolor: "#fff",
        p: 2,
        width: "100%",
      }}
    >
      {/* Left Section */}
      <Box display="flex" alignItems="center" gap={1.5}>
        {/* Search */}
        <TextField
          size="small"
          placeholder="Search"
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={{
            width: 220,
            "& .MuiOutlinedInput-root": {
              borderRadius: 20,
              fontSize: 13,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlinedIcon fontSize="small" color="action" />
              </InputAdornment>
            ),
          }}
        />

        {/* Add Filter */}
        <Button
          variant="outlined"
          size="small"
          startIcon={<FilterAltOutlinedIcon />}
          sx={{
            borderRadius: 20,
            textTransform: "none",
            fontSize: 13,
            px: 2,
          }}
          onClick={onOpenFilters}
        >
          Add Filter
        </Button>

        {/* Column/List View */}
        <IconButton
          size="small"
          onClick={onOpenColumns}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: "50%",            
          }}
        >
          <ViewListOutlinedIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Right Section */}
      <Box display="flex" alignItems="center" justifyContent="flex-end" gap={2}>
        {/* {(role === 'operations' || role === 'admin') && (
          <FormControlLabel
            control={
                <Switch
                checked={checked}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
                />
            }
            label={checked ? "Hide Complete" : "Show Complete"}
          />
        )} */}

        {/* {(role === 'partner') && (
          <FormControlLabel
            control={
                <Switch
                checked={checked}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
                />
            }
            label={checked ? "Hide Submitted" : "Show Submitted"}
          />
        )} */}


        {(role === 'operations' || role === 'admin') && (
          <Box>
              <Button
                variant="contained"
                size="small"
                startIcon={<UploadOutlinedIcon />}
                onClick={onNewRequest}
                sx={{
                  borderRadius: 20,
                  textTransform: "none",
                  fontSize: 13,
                  px: 2,
                  mr: 3
                }}
              >
                New Request
              </Button>
            </Box>
        )}
      </Box>
    </Box>
  );
}
